/* SND-20847 (S-2) — Soundium Market touch points on soundium.lt (Paper p-B-0 S3 / S5 / S7 / S8 / S10).
 * Loaded once per page by sections/snd-topbar.liquid, LT market only. Custom elements, so markup the theme
 * re-renders later (cart drawer, predictive search, lazy mega panels) upgrades by itself:
 *   <snd-mk-count>     „Market · N skelbimai“ (topbar, drawer, footer) — only when N ≥ data-min
 *   <snd-mk-cards>     2–3 compact listing cards (mega menu column, drawer) from /api/featured
 *   <snd-mk-search>    no-results search + 404: the same words on Market (/api/search), 0 → „Įdėk Ieškau“
 *   <snd-mk-cartline>  one cart line under the total when the item's category has ≥ 10 listings
 *   <snd-mk-model>     journal: the article's model — new in the store vs used on Market (/api/model-summary)
 * Data: market.soundium.lt public API (SND-20845), client-side only, 1.5 s timeout, localStorage cache
 * (same `sndmk:` keys and { t, d } shape as sections/snd-market-rail + snippets/snd-market-row). Any failure
 * leaves the server-rendered fallback text in place — a touch point is never an empty box.
 * UTM: utm_source = data-src, utm_medium = soundium-lt, utm_campaign = market-touchpoints, utm_content = state. */
(function () {
  if (window.SndMk) return;
  var BASE = 'https://market.soundium.lt';
  var MIN = 60000;
  var inflight = {};
  var L = {
    lt: {
      word: function (n) { return n % 10 === 1 && n % 100 !== 11 ? 'skelbimas' : (n % 10 === 0 || (n % 100 > 10 && n % 100 < 20)) ? 'skelbimų' : 'skelbimai'; },
      cat: { dj: 'DJ įranga', studio: 'Studija', keys: 'Sintezatoriai', live: 'Gyvas garsas', lighting: 'Apšvietimas', headphones: 'Ausinės', hifi: 'Hi-Fi', guitars: 'Gitaros', drums: 'Būgnai', effects: 'Efektai ir pedalai', records: 'Plokštelės' },
      ask: { dj: 'Keiti seną DJ įrangą?', studio: 'Keiti seną studijos įrangą?', keys: 'Keiti seną sintezatorių?', live: 'Keiti seną garso sistemą?', lighting: 'Keiti seną apšvietimą?', headphones: 'Keiti senas ausines?', hifi: 'Keiti seną Hi-Fi įrangą?', guitars: 'Keiti seną gitarą?', drums: 'Keiti senus būgnus?', effects: 'Keiti seną pedalą?', records: 'Turi plokštelių, kurių nebeklausai?' },
      sell: "Parduok Market'e", days: function (d) { return ', vidutiniškai per ' + d + ' d.'; }, fast: ' per 10 min.',
      unit: { day: '/ para', hour: '/ val.', session: '/ sesija' }, from: 'nuo',
      onMk: "Market'e", all: 'Visi →', none: function (q) { return "Market'e „" + q + "“ dar nėra."; },
      want: function (q) { return 'Įdėk „Ieškau ' + q + '“'; }, wantTail: ' ir nariai pasiūlys.', notYours: 'Nėra tavo? ',
      used: function (n, p) { return "Market'e: " + n + ' ' + (n % 10 === 1 && n % 100 !== 11 ? 'naudotas' : (n % 10 === 0 || (n % 100 > 10 && n % 100 < 20)) ? 'naudotų' : 'naudoti') + ' nuo ' + p; },
      rent: function (p) { return "Market'e: nuoma nuo " + p + ' / para'; }
    },
    en: {
      word: function (n) { return n === 1 ? 'listing' : 'listings'; },
      cat: { dj: 'DJ gear', studio: 'Studio', keys: 'Synths', live: 'Live sound', lighting: 'Lighting', headphones: 'Headphones', hifi: 'Hi-Fi', guitars: 'Guitars', drums: 'Drums', effects: 'Effects and pedals', records: 'Records' },
      ask: { dj: 'Replacing old DJ gear?', studio: 'Replacing old studio gear?', keys: 'Replacing an old synth?', live: 'Replacing an old PA?', lighting: 'Replacing old lights?', headphones: 'Replacing old headphones?', hifi: 'Replacing old Hi-Fi?', guitars: 'Replacing an old guitar?', drums: 'Replacing old drums?', effects: 'Replacing an old pedal?', records: 'Records you no longer play?' },
      sell: 'Sell it on Market', days: function (d) { return ', typically in ' + d + ' days.'; }, fast: ' in 10 min.',
      unit: { day: '/ day', hour: '/ hr', session: '/ session' }, from: 'from',
      onMk: 'On Market', all: 'All →', none: function (q) { return 'No “' + q + '” on Market yet.'; },
      want: function (q) { return 'Post “Wanted: ' + q + '”'; }, wantTail: ' and members will offer.', notYours: 'Not yours? ',
      used: function (n, p) { return 'On Market: ' + n + ' used from ' + p; },
      rent: function (p) { return 'On Market: rent from ' + p + ' / day'; }
    }
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function langOf(el) { return el.dataset.lang === 'lt' ? 'lt' : 'en'; }
  function eur(c, lang) { var v = c / 100; return new Intl.NumberFormat(lang === 'lt' ? 'lt-LT' : 'en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: v % 1 ? 2 : 0, minimumFractionDigits: 0 }).format(v); }
  function price(it, lang) {
    if (it.price_cents == null) return '';
    var T = L[lang];
    return (it.price_from ? T.from + ' ' : '') + eur(it.price_cents, lang) + (it.price_unit && T.unit[it.price_unit] ? ' ' + T.unit[it.price_unit] : '');
  }
  function utm(url, src, content, lang) {
    try {
      var u = new URL(url, BASE);
      if (!/(^|\.)market\.soundium\.(lt|com)$/.test(u.hostname) || u.protocol !== 'https:') u = new URL(BASE + '/');
      u.searchParams.set('utm_source', src); u.searchParams.set('utm_medium', 'soundium-lt');
      u.searchParams.set('utm_campaign', 'market-touchpoints'); if (content) u.searchParams.set('utm_content', content);
      if (lang === 'en') u.searchParams.set('lang', 'en');
      return u.toString();
    } catch (e) { return BASE + '/'; }
  }
  function cached(path, ttl) {
    try { var c = JSON.parse(localStorage.getItem('sndmk:' + path) || 'null'); if (c && Date.now() - c.t < ttl) return c.d; } catch (e) {}
    return null;
  }
  /** cache first (ttl ms), one request per path at a time, 1.5 s (idle prefetches: 10 s) for headers and body together */
  function get(path, ttl, ms) {
    ttl = ttl || 10 * MIN;
    var c = cached(path, ttl);
    if (c) return Promise.resolve(c);
    if (inflight[path]) return inflight[path];
    var ctl = 'AbortController' in window ? new AbortController() : null;
    var tm = setTimeout(function () { if (ctl) ctl.abort(); }, ms || 1500);
    var p = fetch(BASE + path, { signal: ctl && ctl.signal, credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status); return r.json();
    }).then(function (d) {
      clearTimeout(tm);
      try { localStorage.setItem('sndmk:' + path, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    }, function (e) { clearTimeout(tm); throw e; });
    inflight[path] = p;
    p.then(function () { delete inflight[path]; }, function () { delete inflight[path]; });
    return p;
  }
  function decorate(root, src, lang) {
    root.querySelectorAll('a[data-mk-utm]').forEach(function (a) {
      if (a.dataset.mkDone) return;
      a.dataset.mkDone = '1';
      a.href = utm(a.getAttribute('href'), src, a.dataset.mkUtm || 'cta', lang);
    });
  }
  function idle(fn) { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1200 }); else setTimeout(fn, 1200); }

  /* <snd-mk-count data-min="50" data-src="topbar" data-lang="lt"> … [data-mk-off] … [data-mk-on hidden] [data-mk-n] [data-mk-w] */
  class Count extends HTMLElement {
    connectedCallback() { this._init = 1;
      var self = this, lang = langOf(this), src = this.dataset.src || 'topbar', min = Number(this.dataset.min || 50);
      decorate(this, src, lang);
      var cat = this.dataset.cat;
      function paint(st) {
        var n = st && (cat ? st.by_category && st.by_category[cat] : st.active_count);
        if (!(n >= min)) return;
        self.querySelectorAll('[data-mk-n]').forEach(function (e) { e.textContent = String(n); });
        self.querySelectorAll('[data-mk-w]').forEach(function (e) { e.textContent = L[lang].word(n); });
        self.querySelectorAll('[data-mk-off]').forEach(function (e) { e.hidden = true; });
        self.querySelectorAll('[data-mk-on]').forEach(function (e) { e.hidden = false; });
        self.dataset.state = 'count';
      }
      var ttl = Number(this.dataset.ttl || 60) * MIN;
      var c = cached('/api/stats', ttl);
      if (c) return paint(c);
      idle(function () { get('/api/stats', ttl, 10000).then(paint, function () {}); });
    }
  }

  /* <snd-mk-cards data-cat="dj" data-n="2" data-src="mega" data-lang="lt" data-when="hover|idle"> [data-mk-rail] */
  class Cards extends HTMLElement {
    connectedCallback() { this._init = 1;
      var self = this;
      decorate(this, this.dataset.src || 'mega', langOf(this));
      if (this.dataset.when === 'hover') {
        var c = cached(this.path(), 10 * MIN);
        if (c) return this.paint(c);
        var hdr = document.getElementById('header-group') || document;
        var go = function () { hdr.removeEventListener('pointerover', go); hdr.removeEventListener('focusin', go); self.load(); };
        hdr.addEventListener('pointerover', go, { passive: true }); hdr.addEventListener('focusin', go);
      } else if (this.dataset.src !== 'drawer' || matchMedia('(max-width: 989px)').matches) idle(function () { self.load(); });
    }
    path() { return '/api/featured?n=' + encodeURIComponent(this.dataset.n || 2) + '&lang=' + langOf(this) + (this.dataset.cat ? '&category=' + encodeURIComponent(this.dataset.cat) : ''); }
    load() { var self = this; get(this.path(), 10 * MIN, 10000).then(function (d) { self.paint(d); }, function () { self.unskel(); }); }
    unskel() { this.querySelectorAll('.smk-card--skel').forEach(function (e) { e.remove(); }); }
    paint(d) {
      var lang = langOf(this), src = this.dataset.src || 'mega', items = ((d && d.items) || []).slice(0, Number(this.dataset.n || 2));
      var rail = this.querySelector('[data-mk-rail]');
      if (!rail || this.dataset.state === 'ready') return;
      this.unskel();
      if (!items.length) return;
      rail.innerHTML = items.map(function (it, i) {
        var img = it.photo_w400 ? '<img src="' + esc(it.photo_w400) + '" alt="" loading="lazy" decoding="async" width="400" height="300">' : '';
        return '<a class="smk-card" style="--i:' + i + '" href="' + esc(utm(it.url, src, it.kind, lang)) + '"><span class="smk-card__img">' + img + '</span><span class="smk-card__body"><span class="smk-card__t">' + esc(it.title) + '</span><span class="smk-card__p">' + esc(price(it, lang)) + '</span></span></a>';
      }).join('') + rail.innerHTML;
      this.dataset.state = 'ready';
    }
  }

  /* <snd-mk-search data-q="tr-909" data-src="search-empty|404" data-lang="lt"> */
  class Search extends HTMLElement {
    static get observedAttributes() { return ['data-q']; }
    connectedCallback() { this._init = 1; this.run(); }
    // the predictive panel may morph this element in place for the next query
    attributeChangedCallback(name, was, now) { var self = this; if (was !== null && was !== now && this.isConnected) queueMicrotask(function () { self.run(); }); }
    run() {
      var self = this, lang = langOf(this), src = this.dataset.src || 'search-empty', T = L[lang];
      // the 404 response reports request.path as /404 — the shopper's address is the one to read
      var raw = src === '404' ? decodeURIComponent((location.pathname.split('/').filter(Boolean).pop() || '').split('.')[0]) : (this.dataset.q || '');
      var q = raw.replace(/[-_+]+/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 80);
      decorate(this, src, lang);
      if (q.length < 2 || this._q === q) return;
      this._q = q;
      this.dataset.state = 'loading';
      var wantUrl = utm('/skelbti/ieskau/ko?title=' + encodeURIComponent(q), src, 'wanted', lang);
      get('/api/search?q=' + encodeURIComponent(q.toLowerCase()) + '&n=3').then(function (d) {
        if (self._q !== q) return;
        var ls = (d && d.listings) || [], total = (d && d.total) || ls.length;
        var all = utm('/search?q=' + encodeURIComponent(q), src, 'all', lang);
        var want = '<p class="smk-s__want">' + (ls.length ? esc(T.notYours) : esc(T.none(q)) + ' ') + '<a href="' + esc(wantUrl) + '">' + esc(T.want(q)) + '</a>' + esc(T.wantTail) + '</p>';
        if (!ls.length && src === '404') { self.innerHTML = ''; self.dataset.state = 'none'; return; }
        if (!ls.length) { self.innerHTML = '<div class="smk-s smk-s--none" data-settle><span class="smk-dot" aria-hidden="true"></span>' + want + '</div>'; self.dataset.state = 'none'; return; }
        var rows = ls.map(function (it, i) {
          var img = it.photo ? '<img src="' + esc(it.photo) + '" alt="" loading="lazy" decoding="async" width="56" height="56">' : '';
          var meta = [it.city, price(it, lang)].filter(Boolean).join(' · ');
          return '<li><a class="smk-s__row" style="--i:' + i + '" href="' + esc(utm(it.url, src, it.kind, lang)) + '"><span class="smk-s__img">' + img + '</span><span class="smk-s__txt"><span class="smk-s__t">' + esc(it.title) + '</span><span class="smk-s__m">' + esc(meta) + '</span></span></a></li>';
        }).join('');
        self.innerHTML = '<div class="smk-s" data-settle><div class="smk-s__head"><span class="smk-s__h"><span class="smk-dot" aria-hidden="true"></span>' + esc(T.onMk) + ': ' + total + ' ' + esc(T.word(total)) + ' „' + esc(q) + '“</span><a class="smk-s__all" href="' + esc(all) + '">' + esc(T.all) + '</a></div><ul class="smk-s__list" role="list">' + rows + '</ul>' + want + '</div>';
        self.dataset.state = 'ready';
      }, function () { if (self._q === q) self.dataset.state = 'error'; });
    }
  }

  /* <snd-mk-cartline data-cat="dj" data-lang="lt" hidden> — the server leaves it hidden; shown only with stats */
  class CartLine extends HTMLElement {
    static get observedAttributes() { return ['hidden', 'data-cat']; }
    connectedCallback() { this._init = 1; this.run(); }
    // Horizon morphs the re-rendered cart summary into the live one: the server copy is `hidden` and empty, so a
    // morph flips the attribute back — paint again (the cache answers synchronously)
    attributeChangedCallback() { var self = this; if (!this._busy && this.isConnected) queueMicrotask(function () { self.run(); }); }
    run() {
      var self = this, cat = this.dataset.cat, lang = langOf(this), T = L[lang];
      if (!cat || !T.ask[cat]) return;
      function paint(st) {
        self._busy = true;
        var n = st && st.by_category && st.by_category[cat];
        if (!(n >= 10)) { self.hidden = true; self._busy = false; return; }
        var d = st.median_days_to_sale, sold = Number(st.sold_count || 0), days = d != null && sold >= 20;
        var tail = days ? T.days(Math.max(1, Math.round(d))) : T.fast;
        var href = utm('/skelbti?kind=sell&category=' + encodeURIComponent(cat) + '&from=cart', 'cart', days ? 'days' : 'fast', lang);
        self.innerHTML = '<p class="smk-cl"><span class="smk-dot" aria-hidden="true"></span><span>' + esc(T.ask[cat]) + ' <a href="' + esc(href) + '">' + esc(T.sell) + '</a>' + esc(tail) + '</span></p>';
        self.hidden = false;
        self._busy = false;
      }
      var c = cached('/api/stats', 60 * MIN);
      if (c) return paint(c);
      get('/api/stats', 60 * MIN).then(paint, function () {});
    }
  }

  /* <snd-mk-model data-handle="moog-subsequent-37" data-lang="lt" data-src="journal"> [data-mk-line] */
  class Model extends HTMLElement {
    connectedCallback() { this._init = 1;
      var self = this, lang = langOf(this), src = this.dataset.src || 'journal', T = L[lang];
      decorate(this, src, lang);
      if (!this.dataset.handle || this.dataset.state) return;
      this.dataset.state = 'loading';
      get('/api/model-summary?handle=' + encodeURIComponent(this.dataset.handle)).then(function (s) {
        var line = self.querySelector('[data-mk-line]'), btn = self.querySelector('[data-mk-btn]');
        if (!s || !(s.count > 0)) { self.dataset.state = 'none'; return; }
        var txt = s.min_price_cents != null ? T.used(s.count, eur(s.min_price_cents, lang)) : s.min_rent_day_cents != null ? T.rent(eur(s.min_rent_day_cents, lang)) : '';
        if (!txt) { self.dataset.state = 'none'; return; }
        if (line) { line.textContent = txt; line.setAttribute('data-settle', ''); }
        if (btn && s.url) btn.href = utm(s.url, src, s.min_price_cents != null ? 'sell' : 'rent', lang);
        self.dataset.state = 'ready';
      }, function () { self.dataset.state = 'error'; });
    }
  }

  // snd-drawer-sheet moves its markup around; an element upgraded off-document there never gets connectedCallback —
  // start anything connected but not started yet (after load and whenever the menu opens)
  var TAGS = 'snd-mk-count,snd-mk-cards,snd-mk-search,snd-mk-cartline,snd-mk-model';
  function sweep() { document.querySelectorAll(TAGS).forEach(function (e) { if (!e._init && e.connectedCallback && e.isConnected) e.connectedCallback(); }); }
  window.SndMk = { get: get, utm: utm, sweep: sweep };
  [['snd-mk-count', Count], ['snd-mk-cards', Cards], ['snd-mk-search', Search], ['snd-mk-cartline', CartLine], ['snd-mk-model', Model]].forEach(function (p) {
    if (!customElements.get(p[0])) customElements.define(p[0], p[1]);
  });
  if (document.readyState === 'complete') idle(sweep); else window.addEventListener('load', function () { idle(sweep); });
  document.addEventListener('click', function () { setTimeout(sweep, 50); }, { capture: true, passive: true });
  // warm the stats cache so the cart line is there when the drawer opens (no late pop-in)
  idle(function () { get('/api/stats', 60 * MIN, 10000).catch(function () {}); });
})();
